export const environment = {
  production: true,
  backendUrl: 'https://cult.gung.io/'
};
